import { render, staticRenderFns } from "./EmailNotificationViewInfo.vue?vue&type=template&id=3221a986&"
import script from "./EmailNotificationViewInfo.vue?vue&type=script&lang=js&"
export * from "./EmailNotificationViewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports